import { render, staticRenderFns } from "./deanMatrix.vue?vue&type=template&id=0b2c2d68&scoped=true"
import script from "./deanMatrix.vue?vue&type=script&lang=ts"
export * from "./deanMatrix.vue?vue&type=script&lang=ts"
import style0 from "./deanMatrix.vue?vue&type=style&index=0&id=0b2c2d68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2c2d68",
  null
  
)

export default component.exports